"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectedOfferDtoStatusEnum = void 0;
exports.instanceOfRejectedOfferDto = instanceOfRejectedOfferDto;
exports.RejectedOfferDtoFromJSON = RejectedOfferDtoFromJSON;
exports.RejectedOfferDtoFromJSONTyped = RejectedOfferDtoFromJSONTyped;
exports.RejectedOfferDtoToJSON = RejectedOfferDtoToJSON;
exports.RejectedOfferDtoToJSONTyped = RejectedOfferDtoToJSONTyped;
/**
 * @export
 */
exports.RejectedOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * Check if a given object implements the RejectedOfferDto interface.
 */
function instanceOfRejectedOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('rejectedReason' in value) || value['rejectedReason'] === undefined)
        return false;
    if (!('rejectedAt' in value) || value['rejectedAt'] === undefined)
        return false;
    return true;
}
function RejectedOfferDtoFromJSON(json) {
    return RejectedOfferDtoFromJSONTyped(json, false);
}
function RejectedOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'rejectedReason': json['rejectedReason'],
        'rejectedAt': json['rejectedAt'],
    };
}
function RejectedOfferDtoToJSON(json) {
    return RejectedOfferDtoToJSONTyped(json, false);
}
function RejectedOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'rejectedReason': value['rejectedReason'],
        'rejectedAt': value['rejectedAt'],
    };
}
